<template>
  <div class="container">
    <div class="btn-home col-md-12 mt-3 mb-4 d-flex justify-content-end">
      <div class="mt-3 mb-4">
        <button type="button" class="btn btn-outline-main" @click="returnHome">
          <i class="fas fa-arrow-left"></i> Volver
        </button>
      </div>
    </div>
    <div id="div-modal-consultadocs" class="d-flex justify-content-center">
      <div id="div-consultadocs" class="card w-100 mb-lg-5">
        <div class="text-center card-header text-white h4 bg-main">
          <strong>CONSULTAR DOCUMENTOS</strong>
        </div>
        <div class="card-body w-100">
          <div class="row">
            <div class="col-md-12 py-2">
              <div class="row d-flex mx-0">
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 mt-2">
                  <div class="input-group input-group-sm">
                    <span class="input-group-text col-md-4">Desde</span>
                    <input
                      type="date"
                      class="form-control form-control-sm"
                      v-model="filter.begindate"
                      @change="mtdGetData"
                    />
                  </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 mt-2">
                  <div class="input-group input-group-sm">
                    <span class="input-group-text col-md-4">Hasta</span>
                    <input
                      type="date"
                      class="form-control form-control-sm"
                      v-model="filter.enddate"
                      @change="mtdGetData"
                    />
                  </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 mt-2">
                  <div class="input-group input-group-sm">
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="checkboxBoleta"
                        v-model="filter.boleta"
                        @change="mtdSearchFilter"
                      />
                      <label class="form-check-label" for="checkboxBoleta">Boleta</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="checkboxFactura"
                        v-model="filter.factura"
                        @change="mtdSearchFilter"
                      />
                      <label class="form-check-label" for="checkboxFactura">Factura</label>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 mt-2">
                  <div class="input-group input-group-sm">
                    <span class="input-group-text">Monto</span>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="filter.monto"
                      @keypress="isDecimal"
                      @input="mtdSearchFilter"
                      placeholder="Monto"
                    />
                  </div>
                </div>
                <div class="col-md-12 mt-2">
                  <div class="input-group input-group-sm">
                    <span class="input-group-text text-white bg-main">
                      <i class="fas fa-search"></i>&nbsp;&nbsp;Filtrar
                    </span>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      placeholder="Buscar por documento, cliente, serie o número"
                      v-model="search"
                      @input="mtdSearchFilter"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-3 text-center">
              <!-- paginado -->
              <div v-if="cpData.length > 0" class="d-flex justify-content-end mb-2">
                <nav aria-label="Page navigation example">
                  <ul class="pagination mb-1">
                    <li class="page-item">
                      <a class="page-link page" href="javascript:void(0)" @click="backPage">Anterior</a>
                    </li>
                    <li v-if="limitedStepPagination[0] !== 1" class="page-item">
                      <a
                        :class="selectPage === 1 ? 'page-link active' : 'page-link'"
                        href="javascript:void(0)"
                        @click="selectedPage(1)"
                        >1</a
                      >
                    </li>
                    <li v-if="limitedStepPagination[0] > 2" class="page-item disabled">
                      <span class="page-link">...</span>
                    </li>
                    <li v-for="(item, index) in limitedStepPagination" :key="index" class="page-item">
                      <a
                        :class="selectPage === item ? 'page-link active' : 'page-link'"
                        href="javascript:void(0)"
                        @click="selectedPage(item)"
                        >{{ item }}
                      </a>
                    </li>
                    <li
                      v-if="limitedStepPagination[limitedStepPagination.length - 1] < stepPagination.length - 1"
                      class="page-item disabled"
                    >
                      <span class="page-link">...</span>
                    </li>
                    <li
                      v-if="limitedStepPagination[limitedStepPagination.length - 1] !== stepPagination.length"
                      class="page-item"
                    >
                      <a
                        :class="selectPage === limitedStepPagination.length + 2 ? 'page-link active' : 'page-link'"
                        href="javascript:void(0)"
                        @click="selectedPage(stepPagination.length)"
                        >{{ stepPagination.length }}
                      </a>
                    </li>
                    <li class="page-item">
                      <a class="page-link page" href="javascript:void(0)" @click="nextPage">Siguiente</a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="col-md-12 mt-2" id="content-timelinetable">
              <table id="tb-cxc" class="table table-bordered border-main" style="font-size: 11px">
                <caption class="py-0 my-0"></caption>
                <thead class="text-white">
                  <tr class="text-center text-white border-white bg-main align-middle text-xs">
                    <th scope="col">ID</th>
                    <th scope="col">Tipo de documento</th>
                    <th scope="col">Fecha</th>
                    <th scope="col">Serie y número</th>
                    <th scope="col">Cliente</th>
                    <th scope="col">Monto</th>
                    <th scope="col">Error</th>
                    <th scope="col">Estado</th>
                    <th scope="col">Acciones</th>
                  </tr>
                </thead>
                <tbody class="text-xs">
                  <tr class="text-center" v-if="cpData.length === 0">
                    <td colspan="9">No se han encontrado resultados</td>
                  </tr>
                  <tr class="text-center" v-for="(item, index) in cpData" :key="index">
                    <td>{{ item.id }}</td>
                    <td>
                      <span class="badge" :class="item.type == 'factura' ? 'bg-info' : 'bg-secondary'">
                        {{ item.type == "factura" ? "FACTURA" : "BOLETA" }}
                      </span>
                    </td>
                    <td>{{ item.date | formatDate }}</td>
                    <td>{{ item.serie }}-{{ item.number }}</td>
                    <td class="text-start">
                      {{ item.client_document }} - {{ item.client_name }}
                    </td>
                    <td>S/ {{ parseFloat(item.sale.total).toFixed(2) }}</td>
                    <td class="text-danger">{{ item.error || "-" }}</td>
                    <td>
                      <span v-if="item.state == 1" class="badge text-bg-success">{{ item.estado || "ACTIVO" }}</span>
                      <span v-else-if="item.state == 2" class="badge text-bg-danger">{{ item.estado || "ANULADO" }}</span>
                      <span v-else class="badge text-bg-warning">{{ item.estado || "ERROR" }}</span>
                    </td>
                    <td>
                      <button
                        v-if="mtdIsAceptada(item)"
                        type="button"
                        title="Ver documento"
                        class="btn btn-info btn-sm"
                        @click="mtdViewTicket(item)"
                      >
                        <i class="fas fa-ticket-alt"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";

export default {
  name: "c-facturacion-pages-consultardocumentos",
  data() {
    return {
      filter: {
        begindate: null,
        enddate: null,
        boleta: true,
        factura: true,
        monto: "",
      },
      totalPagesToShow: 4,
      page: 0,
      selectPage: 1,
      stepPagination: [],
      dataShow: [],
      data: [],
      search: "",
    };
  },
  created() {
    this.getFirstDayOfMonth();
    this.mtdGetData();
  },
  computed: {
    cpData() {
      return this.dataShow;
    },
    limitedStepPagination() {
      const totalPages = this.stepPagination.length;
      const currentPage = this.selectPage;

      let startPage = 1;
      let endPage = totalPages;
      if (totalPages > this.totalPagesToShow) {
        const halfPagesToShow = Math.floor(this.totalPagesToShow / 2);

        if (currentPage > halfPagesToShow) {
          startPage = currentPage - halfPagesToShow;
          endPage = currentPage + halfPagesToShow - 1;

          if (endPage > totalPages) {
            endPage = totalPages;
            startPage = totalPages - this.totalPagesToShow + 1;
          }
        } else {
          endPage = this.totalPagesToShow;
        }
      }

      return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
    },
  },
  methods: {
    ...mapActions(["get", "post"]),
    getFirstDayOfMonth: function () {
      const currentDate = new Date();
      const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
      const today = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
      this.filter.begindate = firstDayOfMonth.toISOString().split("T")[0];
      this.filter.enddate = today.toISOString().split("T")[0];
    },
    returnHome: function () {
      this.$emit("returnHome");
    },
    isDecimal: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    mtdGetData: function () {
      this.post({
        url: this.$store.getters.get__url + "/Billing/consultarDocumentos",
        token: this.$store.getters.get__token,
        params: {
          begindate: this.filter.begindate,
          enddate: this.filter.enddate,
        },
      })
        .then((response) => {
          this.dataShow = [];
          this.selectPage = 1;
          this.data = response.data;
          if (this.data.length > 0) {
            this.calculateData(10);
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    calculateData(items) {
      if (!this.data) {
        this.dataShow = [];
        return;
      }
      let filteredData = this.data;
      let selectPage = this.selectPage;

      if (this.search.length >= 2 && this.search != "") {
        let query = this.search.toString().toUpperCase();
        filteredData = filteredData.filter((element) => {
          let doc = element.client_document.toString().toUpperCase();
          let name = element.client_name.toString().toUpperCase();
          let serie = element.serie.toString().toUpperCase();
          let number = element.number.toString().toUpperCase();
          return doc.includes(query) || name.includes(query) || serie.includes(query) || number.includes(query);
        });
        selectPage = 1;
      }
      if (!this.filter.boleta) {
        filteredData = filteredData.filter((item) => item.type !== "boleta");
      }
      if (!this.filter.factura) {
        filteredData = filteredData.filter((item) => item.type !== "factura");
      }
      if (this.filter.monto !== "") {
        filteredData = filteredData.filter(
          (item) => parseFloat(item.sale.total) == parseFloat(this.filter.monto)
        );
      }

      let totalPages = Math.ceil(filteredData.length / items);
      this.stepPagination = Array.from({ length: totalPages }, (_, index) => index + 1);
      let startIndex = (selectPage - 1) * items;
      let endIndex = startIndex + (items - 1);
      this.dataShow = filteredData.slice(startIndex, endIndex + 1);
    },
    mtdSearchFilter() {
      this.calculateData(10);
    },
    backPage() {
      this.selectPage = this.selectPage > 1 ? this.selectPage - 1 : 1;
    },
    nextPage() {
      this.selectPage =
        this.selectPage < this.stepPagination.length ? this.selectPage + 1 : this.stepPagination.length;
    },
    selectedPage(page) {
      this.selectPage = page;
    },
    mtdViewTicket: function (url) {
      window.open(JSON.parse(url.enlaces).pdfTicket, "_blank");
    },
    mtdIsAceptada: function (item) {
      return String(item.estado || "").trim().toUpperCase() == "ACEPTADA";
    },
  },
  filters: {
    formatDate(date) {
      return date != null ? moment(date).format("DD/MM/YYYY") : "-";
    },
  },
};
</script>

<style lang="scss" scoped>
.card-header-grey {
  background-color: #8a8a97;
}
</style>
